// extracted by mini-css-extract-plugin
export var bodySections = "_dy-8";
export var gray = "_dy-7";
export var green = "_dy-4";
export var iconContainer = "_dy-9";
export var iconWidgetContainer = "_dy-1";
export var phoneIcon = "_dy-2";
export var red = "_dy-5";
export var statusDot = "_dy-3";
export var widgetContainer = "_dy-0";
export var yellow = "_dy-6";